import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

function Page(props) {
  const { title, children } = props;
  return (
    <div className="content">
      <Typography variant="h1">{title}</Typography>
      {children}
    </div>
  );
}

Page.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Page;



// WEBPACK FOOTER //
// ./src/pages/Page.js